const state = {
    itemCount: 0,
    currentPage: 1,
    perPage: 20,
};

const getters = {
    itemCount: (state) => state.itemCount,
    currentPage: (state) => state.currentPage,
    perPage: (state) => state.perPage,
    pagerParams:  ({currentPage, perPage}) => ([
        ...(currentPage) ? ['page='+parseInt(currentPage)] : [],
        ...(perPage) ? ['per-page='+parseInt(perPage)] : []
    ]),
    lastItem: (state) => Math.min((state.currentPage * state.perPage), state.itemCount),
};

const actions = {

};

const mutations = {
    setItemCount: (state, itemCount) => state.itemCount = itemCount,
    setCurrentPage: (state, page) => state.currentPage = page,
    setPerPage: (state, perPage) => state.perPage = perPage,
};

export default {
    state,
    getters,
    actions,
    mutations,
}